import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SignInPage = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('authToken');
    console.log('Auth token cleared from localStorage.');
  }, []);

  const handleLogin = async () => {
    setError('');
    try {
      const res = await fetch('https://server-ojqx.onrender.com/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('authToken', data.token);
        onLoginSuccess();
        navigate('/admin');
      } else {
        setError(data.error || 'Login failed.');
      }
    } catch (err) {
      console.error('Network or server error during login:', err);
      setError('Failed to connect to the server.');
    }
  };

  return (
    <div className="signin-container">
      <h2>Admin Sign In</h2>
      <input
        type="text"
        placeholder="Enter username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        style={{ marginBottom: '10px' }}
      />
      <input
        type="password"
        placeholder="Enter password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={handleLogin}>Sign In</button>
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default SignInPage;